class OrderStore {


}
export default new OrderStore();
